const text=(e,t={})=>new Response(e,t);module.exports={text:text};